import React, { useEffect } from 'react';
import * as ReactDOM from 'react-dom';

export default function ModalContainer({
  children,
  className = 'root-portal',
  element = 'div'
}) {
  const modalRoot = document.getElementById('portal');
  // eslint-disable-next-line no-unused-vars
  const [container] = React.useState(() => {
    const el = document.createElement(element);
    el.classList.add(className);
    return el;
  });
  useEffect(() => {
    const currentModalCount = Number(document.body.dataset.modalOpenCount || '0') + 1;
    document.body.dataset.modalOpenCount = String(currentModalCount);
    document.body.classList.add('modal-open');

    modalRoot.style.width = '100%';
    modalRoot.style.height = '100%';
    modalRoot.style.position = 'fixed';
    modalRoot.style.display = 'flex';
    modalRoot.style.justifyContent = 'center';
    modalRoot.style.alignItems = 'center';
    modalRoot.style.overflowX = 'hidden';
    modalRoot.style.overflowY = 'auto';
    modalRoot.style.padding = 'max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right)) max(12px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left))';
    modalRoot.style.boxSizing = 'border-box';
    modalRoot.style.overscrollBehavior = 'contain';
    modalRoot.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    modalRoot.style.zIndex = '21';

    return () => {
      const nextModalCount = Math.max(
        Number(document.body.dataset.modalOpenCount || '1') - 1,
        0
      );

      if (nextModalCount === 0) {
        document.body.classList.remove('modal-open');
        delete document.body.dataset.modalOpenCount;
      } else {
        document.body.dataset.modalOpenCount = String(nextModalCount);
      }

      modalRoot.style.width = '0';
      modalRoot.style.height = '0';
      modalRoot.style.backgroundColor = 'transparent';
      modalRoot.style.zIndex = '0';
      modalRoot.style.overflow = 'hidden';
      modalRoot.style.padding = '0';
    };
  }, []);
  return ReactDOM.createPortal(children, modalRoot);
}
